import React from 'react';
import { FDStack, FDBodyText } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { LoadingSequence } from './LoadingSequence';

const LongRunningProcess = ({
  value,
}) => {
  return (
    <FDStack direction={'column'} alignItems={'center'} spacing={2}>
      <LoadingSequence size={60} />
      <FDBodyText value={value} />
    </FDStack>
  );
};

LongRunningProcess.defaultProps = {};

LongRunningProcess.propTypes = {
  value: PropTypes.string.isRequired,
};

export default LongRunningProcess;
